import { atomWithReset } from 'jotai/utils';

export const navbarPropsAtom = atomWithReset<GlobalAppBarProps>({
  isFixed: true,
});
